export const useContentsHelper = () => {
  const { all } = useContents();

  const isContentInUserLibs = (id) => {
    return all.value.findIndex((item) => item.id === id) > -1;
  };

  const isMainContent = (id) => {
    return (
      all.value.findIndex(
        (item) => item.id === id && item.type === UserContentType.MainContent
      ) > -1
    );
  };

  const isContentInUserLibsButNotAsChild = (id) => {
    return (
      all.value.findIndex(
        (item) =>
          item.id === id &&
          item.type !== UserContentType.ChildrenContent &&
          item.type !== 'unDownloadedContent'
      ) > -1
    );
  };

  const isDownloadableContent = (id) => {
    const content = all.value.find((content) => content.id === id);
    if (content) {
      return content.type === UserContentType.UnDownloadedContent;
    } else {
      return true;
    }
  };

  const getIdFromSlug = (slug): string | null => {
    const content = all.value.find((content) => content.slug === slug);
    if (content) {
      return content.id;
    } else {
      return null;
    }
  };

  const getContentFromSlug = (slug): UserContent => {
    const content = all.value.find((content) => content.slug === slug);
    if (content) {
      return content;
    } else {
      return null;
    }
  };

  const getContentsOfMemberId = (memberId: string) => {
    return all.value.find((content) => content.memberId === memberId);
  };

  const getContentPathFromId = (id: string): string | null => {
    const content = all.value.find((content) => content.id === id);

    return content?.path;
  };

  const getContentFromId = (id: string): UserContent => {
    const content = all.value.find((content) => content.id === id);

    return content;
  };

  return {
    isDownloadableContent,
    isContentInUserLibs,
    isContentInUserLibsButNotAsChild,
    getContentPathFromId,
    getIdFromSlug,
    getContentFromSlug,
    getContentsOfMemberId,
    getContentFromId,
    isMainContent,
  };
};
